export default {
  colorPrimary: "#6D0A23",
  colorPrimaryHover: "rgb(177, 32, 68)",
  colorWhite: "#FFFFFF",
  colorGrayDarkOne: "#272626"
};
